import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSpamTabler = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_69_4897)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7.58714 1.66797H12.4155C12.7439 1.66793 13.0691 1.7326 13.3725 1.85829C13.6759 1.98397 13.9516 2.16821 14.1838 2.40047L17.6013 5.81714C17.834 6.04956 18.0186 6.32561 18.1444 6.62948C18.2703 6.93336 18.3349 7.25907 18.3346 7.58797V12.4163C18.3347 12.7447 18.27 13.0699 18.1443 13.3733C18.0186 13.6768 17.8344 13.9524 17.6021 14.1846L14.1855 17.6021C13.9532 17.8346 13.6775 18.0191 13.3739 18.1449C13.0703 18.2708 12.7449 18.3355 12.4163 18.3355H7.58714C7.25866 18.3354 6.93342 18.2706 6.63 18.1448C6.32658 18.0189 6.05093 17.8345 5.8188 17.6021L2.4013 14.1855C2.16869 13.9531 1.98419 13.6772 1.85835 13.3735C1.73252 13.0698 1.66782 12.7442 1.66797 12.4155V7.58714C1.66793 7.25872 1.7326 6.93351 1.85829 6.63009C1.98397 6.32667 2.16821 6.05099 2.40047 5.8188L5.81714 2.4013C6.04956 2.16859 6.32561 1.98403 6.62948 1.85819C6.93336 1.73235 7.25907 1.66771 7.58797 1.66797H7.58714Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 6.66797V10.0013",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 13.332H10.0083",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_69_4897",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgSpamTabler;
